import AppStore from "./AppStore";
import { buildClassName } from "./util";

// id: "93b281a3-5e97-4923-b078-f60713f25c42"
// title: "Members Header"
// type: :reference
// key: "header"
// parent_id: nil
export function Header93b281a35e974923B078F60713f25c42(props: any) {
  return (
    <MembersAreaHeaderOldFc7868f8Ac0749e6875a1e00c68345db parentTag="Header93b281a35e974923B078F60713f25c42" {...props} />
  );
}

// id: "ab8b87ee-0863-4ede-a41f-73026a5f273b"
// title: "Marketing Cards"
// type: :gf_preset
// key: "marketing-cards"
// parent_id: nil
export function MarketingCardsAb8b87ee08634edeA41f73026a5f273b(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <MarketingCards className="MarketingCardsAb8b87ee08634edeA41f73026a5f273b" parentTag={buildClassName("MarketingCardsAb8b87ee08634edeA41f73026a5f273b", parentTag)} postSlug="home-page-posts2" buttonClass="inline-block px-12 py-3 hover:brightness-110 transition duration" {...props} />
  );
}

// id: "6e8678b9-e811-42c2-97a3-c4a2a3912e64"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "9d334415-9a76-4415-a2d5-83babbf3fcca"
export function Footer6e8678b9E81142c297a3C4a2a3912e64(props: any) {
  return (
    <DefaultFooterCc240e6b6de845da9e98B6871451f0ae parentTag="Footer6e8678b9E81142c297a3C4a2a3912e64" {...props} />
  );
}

// id: "49ef487a-3e0d-457b-a941-d252242bb5ff"
// title: ""
// type: :text
// key: "alt"
// parent_id: "bfb6a91d-3409-4839-80e6-c31b3a50e5be"
export const Alt49ef487a3e0d457bA941D252242bb5ff = "logo";

// id: "198a2f3c-d02e-4bd4-9831-40c700168128"
// title: "HREF"
// type: :text
// key: "href"
// parent_id: nil
export const Href198a2f3cD02e4bd4983140c700168128 = "/";

// id: "835a7006-fedf-4a3c-96f6-0c8578d33dd5"
// title: "Resources Page"
// type: :reference
// key: "resources-page"
// parent_id: nil
export function ResourcesPage835a7006Fedf4a3c96f60c8578d33dd5(props: any) {
  return (
    <SecondaryPage25cfe53c26414c11999257489acc0841 parentTag="ResourcesPage835a7006Fedf4a3c96f60c8578d33dd5" header={<SecondaryMarketingHeaderBc93fe8a5c6141d0A496541fd2d4f716 parentTag="HeaderA53e13e4Ec8247b08f5aEbe49c1db91d" title="Resources" />} {...props} />
  );
}

// id: "b2c60fb5-9ea6-432a-b2b3-b8dde85a6ce2"
// title: ""
// type: :gf_preset
// key: "hero"
// parent_id: "eabc1b81-a949-4986-bcf6-74098e4558e8"
export function HeroB2c60fb59ea6432aB2b3B8dde85a6ce2(props: any) {
  const Hero = AppStore.presets["Hero"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Hero className="HeroB2c60fb59ea6432aB2b3B8dde85a6ce2" parentTag={buildClassName("HeroB2c60fb59ea6432aB2b3B8dde85a6ce2", parentTag)} postSlug="home-hero" {...props} />
  );
}

// id: "4bb8d6bd-6561-4d59-8bc5-1adb8c1d543d"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "4c0dc444-4d5e-4051-83db-f6a0ad996433"
export const NavMenuSlug4bb8d6bd65614d598bc51adb8c1d543d = "members-primary-nav";

// id: "ce33b72d-9e0b-4d1d-8091-0c100757ba19"
// title: ""
// type: :reference
// key: "about-susan-header"
// parent_id: "18dceb9f-ff94-4f4d-ad59-34c42f458a84"
export function AboutSusanHeaderCe33b72d9e0b4d1d80910c100757ba19(props: any) {
  return (
    <MembersAreaHeaderOldFc7868f8Ac0749e6875a1e00c68345db parentTag="AboutSusanHeaderCe33b72d9e0b4d1d80910c100757ba19" {...props} />
  );
}

// id: "07bd4b2e-b597-4cdd-b1b1-be38650566ce"
// title: ""
// type: :text
// key: "title"
// parent_id: "0657433f-839d-47d5-925c-8ffd02f66d07"
export const Title07bd4b2eB5974cddB1b1Be38650566ce = "About Susan";

// id: "9d334415-9a76-4415-a2d5-83babbf3fcca"
// title: "Member Pages"
// type: :html
// key: "member-pages-old"
// parent_id: nil
export function MemberPagesOld9d3344159a764415A2d583babbf3fcca(props: any) {
  const PrimaryNavigation = AppStore.presets["PrimaryNavigation"];
  const SecondaryNavigation = AppStore.presets["SecondaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} MemberPagesOld9d3344159a764415A2d583babbf3fcca`}>
      {props["header"] || <MembersAreaHeaderOldFc7868f8Ac0749e6875a1e00c68345db parentTag="Header5a2a8fc48cce46afA5cb357490033e22" {...props} />}
      {props["secondary-nav"] || <SecondaryNavigation className="SecondaryNav3ad71a9bFbc34044Be197d7c5c7146be" parentTag={buildClassName("SecondaryNav3ad71a9bFbc34044Be197d7c5c7146be", parentTag)} {...props} />}
      {props.children}
      {props["footer"] || <DefaultFooterCc240e6b6de845da9e98B6871451f0ae parentTag="Footer6e8678b9E81142c297a3C4a2a3912e64" {...props} />}
    </div>
  );
}

// id: "a1b9cc03-a625-4837-a608-f781e5e93b13"
// title: "Title - Leveling"
// type: :text
// key: "title"
// parent_id: nil
export const TitleA1b9cc03A6254837A608F781e5e93b13 = "Leveling";

// id: "38066c6b-797e-4645-ad4e-a20a2bcf5fdf"
// title: ""
// type: :reference
// key: "header"
// parent_id: "8b19b3d6-071d-4d4b-a2e3-cd7e0536b5b3"
export function Header38066c6b797e4645Ad4eA20a2bcf5fdf(props: any) {
  return (
    <SecondaryMarketingHeaderBc93fe8a5c6141d0A496541fd2d4f716 parentTag="Header38066c6b797e4645Ad4eA20a2bcf5fdf" title="Leveling" {...props} />
  );
}

// id: "3ad71a9b-fbc3-4044-be19-7d7c5c7146be"
// title: ""
// type: :gf_preset
// key: "secondary-nav"
// parent_id: "9d334415-9a76-4415-a2d5-83babbf3fcca"
export function SecondaryNav3ad71a9bFbc34044Be197d7c5c7146be(props: any) {
  const SecondaryNavigation = AppStore.presets["SecondaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <SecondaryNavigation className="SecondaryNav3ad71a9bFbc34044Be197d7c5c7146be" parentTag={buildClassName("SecondaryNav3ad71a9bFbc34044Be197d7c5c7146be", parentTag)} {...props} />
  );
}

// id: "49186fff-c4a3-4c9a-994f-47b0f66e8727"
// title: ""
// type: :reference
// key: "header"
// parent_id: "7d66cde5-8534-459c-965b-5b9012c035f1"
export function Header49186fffC4a34c9a994f47b0f66e8727(props: any) {
  return (
    <MembersAreaHeaderOldFc7868f8Ac0749e6875a1e00c68345db parentTag="Header49186fffC4a34c9a994f47b0f66e8727" navMenuSlug="members-primary-nav" {...props} />
  );
}

// id: "6f5472ee-a0b3-42ca-a667-2b9b529ee4b3"
// title: ""
// type: :reference
// key: "label"
// parent_id: "209fb66c-4d47-4815-aa00-c80823cc9cd3"
export function Label6f5472eeA0b342caA6672b9b529ee4b3(props: any) {
  return (
    <DefaultLogoBfb6a91d3409483980e6C31b3a50e5be parentTag="Label6f5472eeA0b342caA6672b9b529ee4b3" {...props} />
  );
}

// id: "071fdd24-9ede-4246-999b-f08706f717ee"
// title: "Header Area Top"
// type: :html
// key: "default-header-top"
// parent_id: nil
export function DefaultHeaderTop071fdd249ede4246999bF08706f717ee(props: any) {
  const Link = AppStore.presets["Link"];
  const PrimaryNavigation = AppStore.presets["PrimaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} DefaultHeaderTop071fdd249ede4246999bF08706f717ee header-top`}>
      {props["linked-logo"] || <Link className="LinkedLogo034726e6Fdf049079c6cC6894005e717" parentTag={buildClassName("LinkedLogo034726e6Fdf049079c6cC6894005e717", parentTag)} label={<DefaultLogoBfb6a91d3409483980e6C31b3a50e5be parentTag="Label2d74e863Fc984613Bd689342f946d6df" alt="logo" />} className="linked-logo" url="/" {...props} />}
      {props["navigation"] || <PrimaryNavigation className="Navigation8b8a56a6C548471b8b74Befa350529b1" parentTag={buildClassName("Navigation8b8a56a6C548471b8b74Befa350529b1", parentTag)} className="navigation" navMenuSlug="marketing-primary-nav" {...props} />}
    </div>
  );
}

// id: "1b73e945-c298-48f9-9cf6-2e12cc0d8e61"
// title: "Home Page"
// type: :html
// key: "home-page"
// parent_id: nil
export function HomePage1b73e945C29848f99cf62e12cc0d8e61(props: any) {
  const WelcomeBackPopUp = AppStore.presets["WelcomeBackPopUp"];
  const PageQuote = AppStore.presets["PageQuote"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} HomePage1b73e945C29848f99cf62e12cc0d8e61 page`}>
      {props["header"] || <HomeHeaderEabc1b81A9494986Bcf674098e4558e8 parentTag="Header2490b2f512ae4c4a945cDfcc1dbec9b9" {...props} />}
      {props["welcome-back"] || <WelcomeBackPopUp className="WelcomeBackE62b5ab39e1c4d0e8bf02580314720e7" parentTag={buildClassName("WelcomeBackE62b5ab39e1c4d0e8bf02580314720e7", parentTag)} {...props} />}
      {props["body"] || <MarketingBody5563864f8a25444cA7e7E7adc834add8 parentTag="BodyA33e76b14e9d46858c77654c7f89f115" {...props} />}
      {props["quote"] || <PageQuote className="QuoteF3d75a66112c4b188f736251164b57a7" parentTag={buildClassName("QuoteF3d75a66112c4b188f736251164b57a7", parentTag)} contentSlug="home-page-quote" {...props} />}
      {props["footer"] || <DefaultFooterCc240e6b6de845da9e98B6871451f0ae parentTag="FooterCbfc990fDef9493b8daf245ebbcc726c" {...props} />}
    </div>
  );
}

// id: "50eb2226-ba56-46b8-8a9f-21c197a1d29c"
// title: ""
// type: :gf_preset
// key: "button"
// parent_id: "2820f6c3-3d67-4753-986a-3bd1298c4f6f"
export function Button50eb2226Ba5646b88a9f21c197a1d29c(props: any) {
  const Button = AppStore.presets["Button"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Button className="Button50eb2226Ba5646b88a9f21c197a1d29c" parentTag={buildClassName("Button50eb2226Ba5646b88a9f21c197a1d29c", parentTag)} label="Join Us" href="/join" {...props} />
  );
}

// id: "0a104597-b8e1-4cb8-b4d3-cc93d270aa23"
// title: ""
// type: :text
// key: "backgroundImage"
// parent_id: "eabc1b81-a949-4986-bcf6-74098e4558e8"
export const BackgroundImage0a104597B8e14cb8B4d3Cc93d270aa23 = "https://mp1md-pub.s3.amazonaws.com/orgs/tastesoftantra/hero4.jpg";

// id: "0c388b34-08c7-4ec2-bca8-7004c328c44a"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "74e79888-2a33-405d-9c7a-52636e1e4e48"
export function Footer0c388b3408c74ec2Bca87004c328c44a(props: any) {
  return (
    <DefaultFooterCc240e6b6de845da9e98B6871451f0ae parentTag="Footer0c388b3408c74ec2Bca87004c328c44a" {...props} />
  );
}

// id: "f5e22975-33ed-4a49-8d83-3a39d85d79ae"
// title: ""
// type: :text
// key: "title"
// parent_id: "2cd47e35-942a-43af-9f2a-c67c3487d390"
export const TitleF5e2297533ed4a498d833a39d85d79ae = "Secondary Page";

// id: "5563864f-8a25-444c-a7e7-e7adc834add8"
// title: "Marketing Cards Body"
// type: :html
// key: "marketing-body"
// parent_id: nil
export function MarketingBody5563864f8a25444cA7e7E7adc834add8(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} MarketingBody5563864f8a25444cA7e7E7adc834add8 page-body`}>
      {props["marketingCards"] || <MarketingCardsAb8b87ee08634edeA41f73026a5f273b parentTag="MarketingCardsB0a05ceeB2a94de1B3dc5dad4227bc1a" postSlug="home-page-posts2" {...props} />}
    </div>
  );
}

// id: "8b19b3d6-071d-4d4b-a2e3-cd7e0536b5b3"
// title: "Levels 1-4 Explained"
// type: :html
// key: "about-leveling-page"
// parent_id: nil
export function AboutLevelingPage8b19b3d6071d4d4bA2e3Cd7e0536b5b3(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} AboutLevelingPage8b19b3d6071d4d4bA2e3Cd7e0536b5b3`}>
      {props["header"] || <SecondaryMarketingHeaderBc93fe8a5c6141d0A496541fd2d4f716 parentTag="Header38066c6b797e4645Ad4eA20a2bcf5fdf" title="Leveling" {...props} />}
      {props.children}
      {props["footer"] || <DefaultFooterCc240e6b6de845da9e98B6871451f0ae parentTag="Footer514efbf0A4054446B960889811f45913" {...props} />}
    </div>
  );
}

// id: "8b5d91db-05f7-4be3-8a09-7267d0c97010"
// title: "Label"
// type: :reference
// key: "label"
// parent_id: nil
export function Label8b5d91db05f74be38a097267d0c97010(props: any) {
  return (
    <DefaultLogoBfb6a91d3409483980e6C31b3a50e5be parentTag="Label8b5d91db05f74be38a097267d0c97010" {...props} />
  );
}

// id: "368691cd-5ed1-47a1-8f6f-7907b0f20f7d"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "25cfe53c-2641-4c11-9992-57489acc0841"
export function Footer368691cd5ed147a18f6f7907b0f20f7d(props: any) {
  return (
    <DefaultFooterCc240e6b6de845da9e98B6871451f0ae parentTag="Footer368691cd5ed147a18f6f7907b0f20f7d" {...props} />
  );
}

// id: "ad71e068-7e01-415e-9b42-d99dce697150"
// title: ""
// type: :gf_preset
// key: "groupflow"
// parent_id: "cc240e6b-6de8-45da-9e98-b6871451f0ae"
export function GroupflowAd71e0687e01415e9b42D99dce697150(props: any) {
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupFlowTag className="GroupflowAd71e0687e01415e9b42D99dce697150" parentTag={buildClassName("GroupflowAd71e0687e01415e9b42D99dce697150", parentTag)} {...props} />
  );
}

// id: "a1375559-1a10-4f17-adf0-4da4586b3089"
// title: ""
// type: :text
// key: "class"
// parent_id: "a5dcb418-035e-4a5f-92c1-45632725e805"
export const ClassA13755591a104f17Adf04da4586b3089 = "join-us";

// id: "72f7eb28-0d92-4918-98fb-5e7478a8e8d0"
// title: ""
// type: :text
// key: "title"
// parent_id: "7357f4e9-1660-4887-a003-40db9e403349"
export const Title72f7eb280d92491898fb5e7478a8e8d0 = "Join Us";

// id: "a69374e4-0dfa-4a18-9b5e-1d326a09e345"
// title: "Signup Pages"
// type: :reference
// key: "signup-pages"
// parent_id: nil
export function SignupPagesA69374e40dfa4a189b5e1d326a09e345(props: any) {
  return (
    <SecondaryPage25cfe53c26414c11999257489acc0841 parentTag="SignupPagesA69374e40dfa4a189b5e1d326a09e345" header={<SecondaryMarketingHeaderBc93fe8a5c6141d0A496541fd2d4f716 parentTag="Header7357f4e916604887A00340db9e403349" title="Join Us" />} {...props} />
  );
}

// id: "bfb6a91d-3409-4839-80e6-c31b3a50e5be"
// title: "Logo"
// type: :html
// key: "default-logo"
// parent_id: nil
export function DefaultLogoBfb6a91d3409483980e6C31b3a50e5be(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <img src="https://mp1md-pub.s3.amazonaws.com/orgs/tastesoftantra/logo-wide-white.svg" className={`${parentTag || ""} DefaultLogoBfb6a91d3409483980e6C31b3a50e5be logo`} alt="logo" />
  );
}

// id: "c6947626-f9dd-4d28-be99-9e54e100096b"
// title: ""
// type: :reference
// key: "header-top"
// parent_id: "eabc1b81-a949-4986-bcf6-74098e4558e8"
export function HeaderTopC6947626F9dd4d28Be999e54e100096b(props: any) {
  return (
    <DefaultHeaderTop071fdd249ede4246999bF08706f717ee parentTag="HeaderTopC6947626F9dd4d28Be999e54e100096b" {...props} />
  );
}

// id: "a53e13e4-ec82-47b0-8f5a-ebe49c1db91d"
// title: ""
// type: :reference
// key: "header"
// parent_id: "835a7006-fedf-4a3c-96f6-0c8578d33dd5"
export function HeaderA53e13e4Ec8247b08f5aEbe49c1db91d(props: any) {
  return (
    <SecondaryMarketingHeaderBc93fe8a5c6141d0A496541fd2d4f716 parentTag="HeaderA53e13e4Ec8247b08f5aEbe49c1db91d" title="Resources" {...props} />
  );
}

// id: "2cd47e35-942a-43af-9f2a-c67c3487d390"
// title: ""
// type: :reference
// key: "header"
// parent_id: "25cfe53c-2641-4c11-9992-57489acc0841"
export function Header2cd47e35942a43af9f2aC67c3487d390(props: any) {
  return (
    <SecondaryMarketingHeaderBc93fe8a5c6141d0A496541fd2d4f716 parentTag="Header2cd47e35942a43af9f2aC67c3487d390" title="Secondary Page" {...props} />
  );
}

// id: "2d74e863-fc98-4613-bd68-9342f946d6df"
// title: ""
// type: :reference
// key: "label"
// parent_id: "034726e6-fdf0-4907-9c6c-c6894005e717"
export function Label2d74e863Fc984613Bd689342f946d6df(props: any) {
  return (
    <DefaultLogoBfb6a91d3409483980e6C31b3a50e5be parentTag="Label2d74e863Fc984613Bd689342f946d6df" {...props} />
  );
}

// id: "fd53b172-98d2-4c96-9dc3-c331f3015048"
// title: "Public Events Page"
// type: :html
// key: "public-events-page"
// parent_id: nil
export function PublicEventsPageFd53b17298d24c969dc3C331f3015048(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} PublicEventsPageFd53b17298d24c969dc3C331f3015048`}>
      {props["header"] || <SecondaryMarketingHeaderBc93fe8a5c6141d0A496541fd2d4f716 parentTag="Header99929f2dE69b4a6fA1f5457714623d02" title="Public Events" {...props} />}
      {props.children}
      {props["footer"] || <DefaultFooterCc240e6b6de845da9e98B6871451f0ae parentTag="FooterE6cdd07cF45b4584A515F5485035124c" {...props} />}
    </div>
  );
}

// id: "3d48beec-3b63-488a-8fed-d838fd483470"
// title: "Common Footer"
// type: :reference
// key: "footer"
// parent_id: nil
export function Footer3d48beec3b63488a8fedD838fd483470(props: any) {
  return (
    <DefaultFooterCc240e6b6de845da9e98B6871451f0ae parentTag="Footer3d48beec3b63488a8fedD838fd483470" {...props} />
  );
}

// id: "7357f4e9-1660-4887-a003-40db9e403349"
// title: ""
// type: :reference
// key: "header"
// parent_id: "a69374e4-0dfa-4a18-9b5e-1d326a09e345"
export function Header7357f4e916604887A00340db9e403349(props: any) {
  return (
    <SecondaryMarketingHeaderBc93fe8a5c6141d0A496541fd2d4f716 parentTag="Header7357f4e916604887A00340db9e403349" title="Join Us" {...props} />
  );
}

// id: "6881901d-dbdb-4b81-8252-8bca75e98a1a"
// title: ""
// type: :gf_preset
// key: "links"
// parent_id: "cc240e6b-6de8-45da-9e98-b6871451f0ae"
export function Links6881901dDbdb4b8182528bca75e98a1a(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Navigation className="Links6881901dDbdb4b8182528bca75e98a1a" parentTag={buildClassName("Links6881901dDbdb4b8182528bca75e98a1a", parentTag)} navMenuSlug="footer-nav" {...props} />
  );
}

// id: "f0794eab-e04c-4c87-9e26-002c8073476c"
// title: "Marketing Primary Navigation"
// type: :text
// key: "navMenuSlug"
// parent_id: "3d7c1854-ada4-4edb-a74d-19ab3db9bc58"
export const NavMenuSlugF0794eabE04c4c879e26002c8073476c = "marketing-primary-nav";

// id: "f1b701ff-476c-4a52-a80a-a032a4773463"
// title: "Members Area Navigation"
// type: :gf_preset
// key: "navigation"
// parent_id: "5a2a8fc4-8cce-46af-a5cb-357490033e22"
export function NavigationF1b701ff476c4a52A80aA032a4773463(props: any) {
  const PrimaryNavigation = AppStore.presets["PrimaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PrimaryNavigation className="NavigationF1b701ff476c4a52A80aA032a4773463" parentTag={buildClassName("NavigationF1b701ff476c4a52A80aA032a4773463", parentTag)} className="navigation" {...props} />
  );
}

// id: "927c6e94-18c6-45b5-9451-80d1edd3a1d7"
// title: "Secondary Marketing Hero"
// type: :html
// key: "secondary-marketing-hero"
// parent_id: nil
export function SecondaryMarketingHero927c6e9418c645b5945180d1edd3a1d7(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} SecondaryMarketingHero927c6e9418c645b5945180d1edd3a1d7 hero`}>
      <div className="title">
        {props["title"] || Title7624d10f144d4649A9797bad253f0ff1}
      </div>
    </div>
  );
}

// id: "7d66cde5-8534-459c-965b-5b9012c035f1"
// title: "Members Area"
// type: :html
// key: "members-area-default"
// parent_id: nil
export function MembersAreaDefault7d66cde58534459c965b5b9012c035f1(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} MembersAreaDefault7d66cde58534459c965b5b9012c035f1 page`}>
      {props["header"] || <MembersAreaHeaderOldFc7868f8Ac0749e6875a1e00c68345db parentTag="Header49186fffC4a34c9a994f47b0f66e8727" navMenuSlug="members-primary-nav" {...props} />}
      {props["footer"] || <DefaultFooterCc240e6b6de845da9e98B6871451f0ae parentTag="Footer90d64ebdA5944c6cAc0cBcc26931f6a6" {...props} />}
    </div>
  );
}

// id: "3cb639f8-a6ff-473d-9596-9a7363f3837f"
// title: ""
// type: :text
// key: "title"
// parent_id: "bc93fe8a-5c61-41d0-a496-541fd2d4f716"
export const Title3cb639f8A6ff473d95969a7363f3837f = "Secondary Marketing Title 1";

// id: "0414380b-3543-409c-a1f3-bb21fe2bd0c4"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "ab8b87ee-0863-4ede-a41f-73026a5f273b"
export const PostSlug0414380b3543409cA1f3Bb21fe2bd0c4 = "home-page-posts2";

// id: "4eaee5ba-3390-4cf2-9eec-930622dc8549"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "18dceb9f-ff94-4f4d-ad59-34c42f458a84"
export function Footer4eaee5ba33904cf29eec930622dc8549(props: any) {
  return (
    <DefaultFooterCc240e6b6de845da9e98B6871451f0ae parentTag="Footer4eaee5ba33904cf29eec930622dc8549" {...props} />
  );
}

// id: "210e2856-7945-4046-9fd3-7019daf8760c"
// title: ""
// type: :text
// key: "class"
// parent_id: "034726e6-fdf0-4907-9c6c-c6894005e717"
export const Class210e2856794540469fd37019daf8760c = "linked-logo";

// id: "4c0dc444-4d5e-4051-83db-f6a0ad996433"
// title: "About SuSun"
// type: :html
// key: "about-susan"
// parent_id: nil
export function AboutSusan4c0dc4444d5e405183dbF6a0ad996433(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} AboutSusan4c0dc4444d5e405183dbF6a0ad996433`} navMenuSlug="members-primary-nav">
      {props["about-susan-header"] || <MembersAreaHeaderOldFc7868f8Ac0749e6875a1e00c68345db parentTag="AboutSusanHeader132bc6a4B2fc46508404Ec358537ef99" {...props} />}
      {props["about-susan-main"] || <AboutSusanMain25b7377730a04000A66a12e63adfcf91 />}
      {props["footer"] || <DefaultFooterCc240e6b6de845da9e98B6871451f0ae parentTag="Footer6f24f00bA0d44b61A3492965ba422092" {...props} />}
    </div>
  );
}

// id: "cc240e6b-6de8-45da-9e98-b6871451f0ae"
// title: "Footer"
// type: :html
// key: "default-footer"
// parent_id: nil
export function DefaultFooterCc240e6b6de845da9e98B6871451f0ae(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <footer className={`${parentTag || ""} DefaultFooterCc240e6b6de845da9e98B6871451f0ae footer`}>
      {props["links"] || <Navigation className="Links6881901dDbdb4b8182528bca75e98a1a" parentTag={buildClassName("Links6881901dDbdb4b8182528bca75e98a1a", parentTag)} navMenuSlug="footer-nav" {...props} />}
      <div className="logo-wrapper">
        {props["logo"] || <LogoFf35e4d41148430c9b2b63af39c68626 />}
      </div>
      {props["copyright"] || <GroupCopyright className="CopyrightC8bdeb4aEcd14098947f88ee3941b840" parentTag={buildClassName("CopyrightC8bdeb4aEcd14098947f88ee3941b840", parentTag)} {...props} />}
      {props["groupflow"] || <GroupFlowTag className="GroupflowAd71e0687e01415e9b42D99dce697150" parentTag={buildClassName("GroupflowAd71e0687e01415e9b42D99dce697150", parentTag)} {...props} />}
    </footer>
  );
}

// id: "6f24f00b-a0d4-4b61-a349-2965ba422092"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "4c0dc444-4d5e-4051-83db-f6a0ad996433"
export function Footer6f24f00bA0d44b61A3492965ba422092(props: any) {
  return (
    <DefaultFooterCc240e6b6de845da9e98B6871451f0ae parentTag="Footer6f24f00bA0d44b61A3492965ba422092" {...props} />
  );
}

// id: "7624d10f-144d-4649-a979-7bad253f0ff1"
// title: ""
// type: :text
// key: "title"
// parent_id: "927c6e94-18c6-45b5-9451-80d1edd3a1d7"
export const Title7624d10f144d4649A9797bad253f0ff1 = "Default Title";

// id: "5a2a8fc4-8cce-46af-a5cb-357490033e22"
// title: ""
// type: :reference
// key: "header"
// parent_id: "9d334415-9a76-4415-a2d5-83babbf3fcca"
export function Header5a2a8fc48cce46afA5cb357490033e22(props: any) {
  const PrimaryNavigation = AppStore.presets["PrimaryNavigation"];
  return (
    <MembersAreaHeaderOldFc7868f8Ac0749e6875a1e00c68345db parentTag="Header5a2a8fc48cce46afA5cb357490033e22" {...props} />
  );
}

// id: "f884d2f6-831b-405e-856b-e704f0c802c3"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "838b17a7-9be9-466b-b7d2-eec8def13281"
export const PostSlugF884d2f6831b405e856bE704f0c802c3 = "about-us-posts";

// id: "6d0e7dde-5b89-4012-b317-2d2b8e701f72"
// title: "Message Pages"
// type: :html
// key: "message-pages"
// parent_id: nil
export function MessagePages6d0e7dde5b894012B3172d2b8e701f72(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} MessagePages6d0e7dde5b894012B3172d2b8e701f72`}>
      {props["header"] || <MembersAreaHeaderOldFc7868f8Ac0749e6875a1e00c68345db parentTag="HeaderDecafed5301e4de4Abc78eabecea51eb" {...props} />}
      {props.children}
    </div>
  );
}

// id: "eabc1b81-a949-4986-bcf6-74098e4558e8"
// title: "Home Header"
// type: :html
// key: "home-header"
// parent_id: nil
export function HomeHeaderEabc1b81A9494986Bcf674098e4558e8(props: any) {
  const Hero = AppStore.presets["Hero"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} HomeHeaderEabc1b81A9494986Bcf674098e4558e8 site-header`}>
      <div className="header-top-wrapper">
        <div className="header-top-opacity">
        </div>
        {props["header-top"] || <DefaultHeaderTop071fdd249ede4246999bF08706f717ee parentTag="HeaderTopC6947626F9dd4d28Be999e54e100096b" {...props} />}
      </div>
      <div className="relative hero-wrapper">
        <div className="background-image" />
        {props["hero"] || <Hero className="HeroB2c60fb59ea6432aB2b3B8dde85a6ce2" parentTag={buildClassName("HeroB2c60fb59ea6432aB2b3B8dde85a6ce2", parentTag)} postSlug="home-hero" {...props} />}
      </div>
    </div>
  );
}

// id: "838b17a7-9be9-466b-b7d2-eec8def13281"
// title: ""
// type: :reference
// key: "body"
// parent_id: "74e79888-2a33-405d-9c7a-52636e1e4e48"
export function Body838b17a79be9466bB7d2Eec8def13281(props: any) {
  return (
    <MarketingBody5563864f8a25444cA7e7E7adc834add8 parentTag="Body838b17a79be9466bB7d2Eec8def13281" postSlug="about-us-posts" {...props} />
  );
}

// id: "b0a05cee-b2a9-4de1-b3dc-5dad4227bc1a"
// title: ""
// type: :reference
// key: "marketingCards"
// parent_id: "5563864f-8a25-444c-a7e7-e7adc834add8"
export function MarketingCardsB0a05ceeB2a94de1B3dc5dad4227bc1a(props: any) {
  return (
    <MarketingCardsAb8b87ee08634edeA41f73026a5f273b parentTag="MarketingCardsB0a05ceeB2a94de1B3dc5dad4227bc1a" postSlug="home-page-posts2" {...props} />
  );
}

// id: "139ba2da-7a5d-4843-b61d-e0832b539c85"
// title: ""
// type: :text
// key: "class"
// parent_id: "8b8a56a6-c548-471b-8b74-befa350529b1"
export const Class139ba2da7a5d4843B61dE0832b539c85 = "navigation";

// id: "b01b3de5-d10e-468c-a91d-f9118cf6fe1a"
// title: ""
// type: :text
// key: "title"
// parent_id: "99929f2d-e69b-4a6f-a1f5-457714623d02"
export const TitleB01b3de5D10e468cA91dF9118cf6fe1a = "Public Events";

// id: "761775b0-54d6-41bf-9304-4773a20b6bb7"
// title: "Admin Pages"
// type: :html
// key: "admin-pages"
// parent_id: nil
export function AdminPages761775b054d641bf93044773a20b6bb7(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} AdminPages761775b054d641bf93044773a20b6bb7`}>
      {props.children}
    </div>
  );
}

// id: "fc7868f8-ac07-49e6-875a-1e00c68345db"
// title: "Members Area Header"
// type: :reference
// key: "members-area-header-old"
// parent_id: nil
export function MembersAreaHeaderOldFc7868f8Ac0749e6875a1e00c68345db(props: any) {
  return (
    <DefaultHeaderTop071fdd249ede4246999bF08706f717ee parentTag="MembersAreaHeaderOldFc7868f8Ac0749e6875a1e00c68345db" navMenuSlug="members-primary-nav" header-top={<DefaultHeaderTop071fdd249ede4246999bF08706f717ee parentTag="HeaderTop642b355a8a5d4eaf9abe83986baf06ed" navMenuSlug="members-primary-nav" />} {...props} />
  );
}

// id: "e62b5ab3-9e1c-4d0e-8bf0-2580314720e7"
// title: ""
// type: :gf_preset
// key: "welcome-back"
// parent_id: "1b73e945-c298-48f9-9cf6-2e12cc0d8e61"
export function WelcomeBackE62b5ab39e1c4d0e8bf02580314720e7(props: any) {
  const WelcomeBackPopUp = AppStore.presets["WelcomeBackPopUp"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <WelcomeBackPopUp className="WelcomeBackE62b5ab39e1c4d0e8bf02580314720e7" parentTag={buildClassName("WelcomeBackE62b5ab39e1c4d0e8bf02580314720e7", parentTag)} {...props} />
  );
}

// id: "2e8b1e2c-c0fc-4e65-8004-89adb5a6cd26"
// title: ""
// type: :reference
// key: "hero"
// parent_id: "bc93fe8a-5c61-41d0-a496-541fd2d4f716"
export function Hero2e8b1e2cC0fc4e65800489adb5a6cd26(props: any) {
  return (
    <SecondaryMarketingHero927c6e9418c645b5945180d1edd3a1d7 parentTag="Hero2e8b1e2cC0fc4e65800489adb5a6cd26" title="Secondary Marketing Title 2" {...props} />
  );
}

// id: "e559f2a3-ba58-4d74-a2fe-8eb9bd33f100"
// title: ""
// type: :text
// key: "title"
// parent_id: "a53e13e4-ec82-47b0-8f5a-ebe49c1db91d"
export const TitleE559f2a3Ba584d74A2fe8eb9bd33f100 = "Resources";

// id: "ef105dc4-86c3-4b98-9345-5d3c283c80d7"
// title: ""
// type: :text
// key: "label"
// parent_id: "50eb2226-ba56-46b8-8a9f-21c197a1d29c"
export const LabelEf105dc486c34b9893455d3c283c80d7 = "Join Us";

// id: "2820f6c3-3d67-4753-986a-3bd1298c4f6f"
// title: "Home Page Hero"
// type: :html
// key: "home-page-hero"
// parent_id: nil
export function HomePageHero2820f6c33d674753986a3bd1298c4f6f(props: any) {
  const Button = AppStore.presets["Button"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} HomePageHero2820f6c33d674753986a3bd1298c4f6f hero`}>
      <div className="title">
        Remember you are the Magic
      </div>
      <div className="button">
        {props["button"] || <Button className="Button50eb2226Ba5646b88a9f21c197a1d29c" parentTag={buildClassName("Button50eb2226Ba5646b88a9f21c197a1d29c", parentTag)} label="Join Us" href="/join" {...props} />}
      </div>
    </div>
  );
}

// id: "ff35e4d4-1148-430c-9b2b-63af39c68626"
// title: ""
// type: :html
// key: "logo"
// parent_id: "cc240e6b-6de8-45da-9e98-b6871451f0ae"
export function LogoFf35e4d41148430c9b2b63af39c68626(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <img src="https://mp1md-pub.s3.amazonaws.com/orgs/tastesoftantra/logo-wide-white.svg" alt="Demo 1 logo" className={`${parentTag || ""} LogoFf35e4d41148430c9b2b63af39c68626 logo`} />
  );
}

// id: "90d64ebd-a594-4c6c-ac0c-bcc26931f6a6"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "7d66cde5-8534-459c-965b-5b9012c035f1"
export function Footer90d64ebdA5944c6cAc0cBcc26931f6a6(props: any) {
  return (
    <DefaultFooterCc240e6b6de845da9e98B6871451f0ae parentTag="Footer90d64ebdA5944c6cAc0cBcc26931f6a6" {...props} />
  );
}

// id: "e6cdd07c-f45b-4584-a515-f5485035124c"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "fd53b172-98d2-4c96-9dc3-c331f3015048"
export function FooterE6cdd07cF45b4584A515F5485035124c(props: any) {
  return (
    <DefaultFooterCc240e6b6de845da9e98B6871451f0ae parentTag="FooterE6cdd07cF45b4584A515F5485035124c" {...props} />
  );
}

// id: "9bfc3b14-5c18-4fb5-afda-3697bf19839e"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "f3d75a66-112c-4b18-8f73-6251164b57a7"
export const ContentSlug9bfc3b145c184fb5Afda3697bf19839e = "home-page-quote";

// id: "62816ae6-0e8c-4125-8ae0-eca21db15e2b"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "6881901d-dbdb-4b81-8252-8bca75e98a1a"
export const NavMenuSlug62816ae60e8c41258ae0Eca21db15e2b = "footer-nav";

// id: "18dceb9f-ff94-4f4d-ad59-34c42f458a84"
// title: "Offerings"
// type: :html
// key: "about-offerings"
// parent_id: nil
export function AboutOfferings18dceb9fFf944f4dAd5934c42f458a84(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} AboutOfferings18dceb9fFf944f4dAd5934c42f458a84`}>
      {props["about-susan-header"] || <MembersAreaHeaderOldFc7868f8Ac0749e6875a1e00c68345db parentTag="AboutSusanHeaderCe33b72d9e0b4d1d80910c100757ba19" {...props} />}
      <main>
        <div>
          <div className="gf-cols-2 content-width">
            <div className="image">
              <img src="https://mp1md-pub.s3.amazonaws.com/orgs/tastesoftantra/images/altar.webp" alt="Altar" className="block-image" />
            </div>
            <div className="text-block-vertical">
              <div className="heading">
                What to expect from a session
              </div>
              <ul>
                <li>
                  Reduced stress and anxiety
                </li>
                <li>
                  Increased energetic awareness
                </li>
                <li>
                  Develop more compassion for yourself and others
                </li>
                <li>
                  More capacity to live the life of your dreams
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="hero brave">
          <div className="text-block text-block-vertical content-width">
            <div className="heading">
              You&#39;re so brave for showing up!
            </div>
            <p>
              Humans come to me for a variety of different reasons. Healing is a
              very unique journey for everyone. I want to highlight my different
              offerings, yet create space to co-create something perfect for you.
            </p>
          </div>
        </div>
        <div>
          <div className="grid-blocks content-width">
            <div className="image-text-block">
              <div className="image">
                <img src="https://mp1md-pub.s3.amazonaws.com/orgs/tastesoftantra/images/susan-massage.webp" alt="SuSun massage" />
              </div>
              <div className="text">
                <div className="heading">
                  Tantric Awakening
                </div>
                <p>
                  Feel more in your body.
                </p>
                <p>
                  More pleasure. More space. More freedom.
                </p>
                <p>
                  Allow yourself to relax, receive, and enjoy.
                </p>
              </div>
            </div>
            <div className="image-text-block">
              <div className="image">
                <img src="https://mp1md-pub.s3.amazonaws.com/orgs/tastesoftantra/images/pray-art.webp" alt="Chakra" />
              </div>
              <div className="text">
                <div className="heading">
                  Chakra Alignment
                </div>
                <p>
                  Clear out stagnant energy, quiet the noise.
                </p>
                <p>
                  Through Reiki we can prepare your energetic body for a vibrational
                  shift.
                </p>
                <p>
                  Increased intuitive awareness and psychic sensitivity.
                </p>
              </div>
            </div>
            <div className="image-text-block">
              <div className="image">
                <img src="https://mp1md-pub.s3.amazonaws.com/orgs/tastesoftantra/images/sacred-foot.webp" alt="Kinky Tasting" />
              </div>
              <div className="text">
                <div className="heading">
                  Kinky Tasting
                </div>
                <p>
                  Do you have an itch to explore?
                </p>
                <p>
                  Something you have always wanted to try?
                </p>
                <p>
                  Let&#39;s get a taste of those passions you may be a bit shy to talk
                  about.
                </p>
                <p>
                  Through consent, negotiation and boundaries we can explore in new
                  ways.
                </p>
              </div>
            </div>
            <div className="image-text-block">
              <div className="image">
                <img src="https://mp1md-pub.s3.amazonaws.com/orgs/tastesoftantra/images/susan-guiding.webp" alt="SuSun guiding a student" />
              </div>
              <div className="text">
                <div className="heading">
                  Becoming Sex-Positive
                </div>
                <p>
                  Build your communication skills, knowledge and understanding.
                </p>
                <p>
                  Learn your somatic YES, body awareness and the confidence to bring
                  all of yourself into community.
                </p>
                <p>
                  Take a road trip into new and exciting ways of being in
                  relationship.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div>
          <a href="/members/messages/x1RwUD7TogtZzODN" className="Button">
            Walking with me
          </a>
        </div>
      </main>
      {props["footer"] || <DefaultFooterCc240e6b6de845da9e98B6871451f0ae parentTag="Footer4eaee5ba33904cf29eec930622dc8549" {...props} />}
    </div>
  );
}

// id: "da77ccf9-bcbc-48a0-8965-c30469d0686d"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "fc7868f8-ac07-49e6-875a-1e00c68345db"
export const NavMenuSlugDa77ccf9Bcbc48a08965C30469d0686d = "members-primary-nav";

// id: "89b61f84-0574-467e-82cf-e490d817f3aa"
// title: ""
// type: :reference
// key: "header-top"
// parent_id: "bc93fe8a-5c61-41d0-a496-541fd2d4f716"
export function HeaderTop89b61f840574467e82cfE490d817f3aa(props: any) {
  return (
    <DefaultHeaderTop071fdd249ede4246999bF08706f717ee parentTag="HeaderTop89b61f840574467e82cfE490d817f3aa" {...props} />
  );
}

// id: "a33e76b1-4e9d-4685-8c77-654c7f89f115"
// title: ""
// type: :reference
// key: "body"
// parent_id: "1b73e945-c298-48f9-9cf6-2e12cc0d8e61"
export function BodyA33e76b14e9d46858c77654c7f89f115(props: any) {
  return (
    <MarketingBody5563864f8a25444cA7e7E7adc834add8 parentTag="BodyA33e76b14e9d46858c77654c7f89f115" {...props} />
  );
}

// id: "7b1f7451-055c-4956-acbb-0eae3f6252d1"
// title: ""
// type: :text
// key: "url"
// parent_id: "034726e6-fdf0-4907-9c6c-c6894005e717"
export const Url7b1f7451055c4956Acbb0eae3f6252d1 = "/";

// id: "60453c6f-3b45-4871-ab71-5fd83801da31"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "49186fff-c4a3-4c9a-994f-47b0f66e8727"
export const NavMenuSlug60453c6f3b454871Ab715fd83801da31 = "members-primary-nav";

// id: "bc93fe8a-5c61-41d0-a496-541fd2d4f716"
// title: "Secondary Marketing Header"
// type: :html
// key: "secondary-marketing-header"
// parent_id: nil
export function SecondaryMarketingHeaderBc93fe8a5c6141d0A496541fd2d4f716(props: any) {
  const { parentTag, ...rest } = props;
  props = { title: "Secondary Marketing Title 1", ...rest };
  return (
    <div className={`${parentTag || ""} SecondaryMarketingHeaderBc93fe8a5c6141d0A496541fd2d4f716 site-header`}>
      <div className="background-image" />
      <div className="header-top-wrapper">
        <div className="header-top-opacity">
        </div>
        {props["header-top"] || <DefaultHeaderTop071fdd249ede4246999bF08706f717ee parentTag="HeaderTop89b61f840574467e82cfE490d817f3aa" {...props} />}
      </div>
      {props["hero"] || <SecondaryMarketingHero927c6e9418c645b5945180d1edd3a1d7 parentTag="Hero2e8b1e2cC0fc4e65800489adb5a6cd26" title="Secondary Marketing Title 2" {...props} />}
    </div>
  );
}

// id: "2490b2f5-12ae-4c4a-945c-dfcc1dbec9b9"
// title: ""
// type: :reference
// key: "header"
// parent_id: "1b73e945-c298-48f9-9cf6-2e12cc0d8e61"
export function Header2490b2f512ae4c4a945cDfcc1dbec9b9(props: any) {
  return (
    <HomeHeaderEabc1b81A9494986Bcf674098e4558e8 parentTag="Header2490b2f512ae4c4a945cDfcc1dbec9b9" {...props} />
  );
}

// id: "209fb66c-4d47-4815-aa00-c80823cc9cd3"
// title: ""
// type: :gf_preset
// key: "linked-logo"
// parent_id: "6441100d-caf1-4dd4-b052-d2ed9361f3ec"
export function LinkedLogo209fb66c4d474815Aa00C80823cc9cd3(props: any) {
  const Link = AppStore.presets["Link"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Link className="LinkedLogo209fb66c4d474815Aa00C80823cc9cd3" parentTag={buildClassName("LinkedLogo209fb66c4d474815Aa00C80823cc9cd3", parentTag)} label={<DefaultLogoBfb6a91d3409483980e6C31b3a50e5be parentTag="Label6f5472eeA0b342caA6672b9b529ee4b3" alt="logo" />} {...props} />
  );
}

// id: "99929f2d-e69b-4a6f-a1f5-457714623d02"
// title: ""
// type: :reference
// key: "header"
// parent_id: "fd53b172-98d2-4c96-9dc3-c331f3015048"
export function Header99929f2dE69b4a6fA1f5457714623d02(props: any) {
  return (
    <SecondaryMarketingHeaderBc93fe8a5c6141d0A496541fd2d4f716 parentTag="Header99929f2dE69b4a6fA1f5457714623d02" title="Public Events" {...props} />
  );
}

// id: "4dc2e39e-09cd-405f-9fb7-9dde2e60997b"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "ea5e257b-e226-4f75-8a78-bfa72721bbb8"
export const NavMenuSlug4dc2e39e09cd405f9fb79dde2e60997b = "members-primary-nav";

// id: "991c50e5-238e-402e-b047-ff09994e3430"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "642b355a-8a5d-4eaf-9abe-83986baf06ed"
export const NavMenuSlug991c50e5238e402eB047Ff09994e3430 = "members-primary-nav";

// id: "a5dcb418-035e-4a5f-92c1-45632725e805"
// title: "Join Us Page"
// type: :reference
// key: "join-us-page"
// parent_id: nil
export function JoinUsPageA5dcb418035e4a5f92c145632725e805(props: any) {
  return (
    <SecondaryPage25cfe53c26414c11999257489acc0841 parentTag="JoinUsPageA5dcb418035e4a5f92c145632725e805" className="join-us" header={<SecondaryMarketingHeaderBc93fe8a5c6141d0A496541fd2d4f716 parentTag="Header7837105a2ae04a6785ed2ba73e199b55" title="Join Us" />} {...props} />
  );
}

// id: "f3d75a66-112c-4b18-8f73-6251164b57a7"
// title: ""
// type: :gf_preset
// key: "quote"
// parent_id: "1b73e945-c298-48f9-9cf6-2e12cc0d8e61"
export function QuoteF3d75a66112c4b188f736251164b57a7(props: any) {
  const PageQuote = AppStore.presets["PageQuote"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PageQuote className="QuoteF3d75a66112c4b188f736251164b57a7" parentTag={buildClassName("QuoteF3d75a66112c4b188f736251164b57a7", parentTag)} contentSlug="home-page-quote" {...props} />
  );
}

// id: "642b355a-8a5d-4eaf-9abe-83986baf06ed"
// title: ""
// type: :reference
// key: "header-top"
// parent_id: "fc7868f8-ac07-49e6-875a-1e00c68345db"
export function HeaderTop642b355a8a5d4eaf9abe83986baf06ed(props: any) {
  return (
    <DefaultHeaderTop071fdd249ede4246999bF08706f717ee parentTag="HeaderTop642b355a8a5d4eaf9abe83986baf06ed" navMenuSlug="members-primary-nav" {...props} />
  );
}

// id: "4e6b9cdf-9a61-44ab-a59f-e5702ac3780e"
// title: ""
// type: :text
// key: "title"
// parent_id: "2e8b1e2c-c0fc-4e65-8004-89adb5a6cd26"
export const Title4e6b9cdf9a6144abA59fE5702ac3780e = "Secondary Marketing Title 2";

// id: "7c5f898c-f7ca-4a85-a6eb-d851af3134df"
// title: ""
// type: :text
// key: "class"
// parent_id: "f1b701ff-476c-4a52-a80a-a032a4773463"
export const Class7c5f898cF7ca4a85A6ebD851af3134df = "navigation";

// id: "74e79888-2a33-405d-9c7a-52636e1e4e48"
// title: "About Us"
// type: :html
// key: "about-us-page"
// parent_id: nil
export function AboutUsPage74e798882a33405d9c7a52636e1e4e48(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} AboutUsPage74e798882a33405d9c7a52636e1e4e48 page`}>
      {props["header"] || <SecondaryMarketingHeaderBc93fe8a5c6141d0A496541fd2d4f716 parentTag="Header0657433f839d47d5925c8ffd02f66d07" title="About Susan" {...props} />}
      <main className="main">
        About Susan - TBD
      </main>
      {props["footer"] || <DefaultFooterCc240e6b6de845da9e98B6871451f0ae parentTag="Footer0c388b3408c74ec2Bca87004c328c44a" {...props} />}
    </div>
  );
}

// id: "d31d5c92-7418-447e-a694-940eff4a32be"
// title: ""
// type: :text
// key: "backgroundImage"
// parent_id: "6441100d-caf1-4dd4-b052-d2ed9361f3ec"
export const BackgroundImageD31d5c927418447eA694940eff4a32be = "https://mp1md-pub.s3.amazonaws.com/orgs/sample/city-background.jpg";

// id: "514efbf0-a405-4446-b960-889811f45913"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "8b19b3d6-071d-4d4b-a2e3-cd7e0536b5b3"
export function Footer514efbf0A4054446B960889811f45913(props: any) {
  return (
    <DefaultFooterCc240e6b6de845da9e98B6871451f0ae parentTag="Footer514efbf0A4054446B960889811f45913" {...props} />
  );
}

// id: "21e3de76-db39-4b66-a8e5-62c9d85219c4"
// title: ""
// type: :text
// key: "buttonClass"
// parent_id: "ab8b87ee-0863-4ede-a41f-73026a5f273b"
export const ButtonClass21e3de76Db394b66A8e562c9d85219c4 = "inline-block px-12 py-3 hover:brightness-110 transition duration";

// id: "5c08bd78-89e0-4d77-b658-acb183fbd995"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "b2c60fb5-9ea6-432a-b2b3-b8dde85a6ce2"
export const PostSlug5c08bd7889e04d77B658Acb183fbd995 = "home-hero";

// id: "4735746f-ad7a-48b4-83be-db41374fbe66"
// title: "Page Quote"
// type: :html
// key: "page-quote"
// parent_id: nil
export function PageQuote4735746fAd7a48b483beDb41374fbe66(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} PageQuote4735746fAd7a48b483beDb41374fbe66`}>
      <div>
      </div>
      <div>
      </div>
    </div>
  );
}

// id: "9ab527db-eac1-4b75-a702-167f96379082"
// title: ""
// type: :text
// key: "imageUrl"
// parent_id: "bfb6a91d-3409-4839-80e6-c31b3a50e5be"
export const ImageUrl9ab527dbEac14b75A702167f96379082 = "https://mp1md-pub.s3.amazonaws.com/orgs/tastesoftantra/logo-wide-white.svg";

// id: "0657433f-839d-47d5-925c-8ffd02f66d07"
// title: ""
// type: :reference
// key: "header"
// parent_id: "74e79888-2a33-405d-9c7a-52636e1e4e48"
export function Header0657433f839d47d5925c8ffd02f66d07(props: any) {
  return (
    <SecondaryMarketingHeaderBc93fe8a5c6141d0A496541fd2d4f716 parentTag="Header0657433f839d47d5925c8ffd02f66d07" title="About Susan" {...props} />
  );
}

// id: "c8bdeb4a-ecd1-4098-947f-88ee3941b840"
// title: ""
// type: :gf_preset
// key: "copyright"
// parent_id: "cc240e6b-6de8-45da-9e98-b6871451f0ae"
export function CopyrightC8bdeb4aEcd14098947f88ee3941b840(props: any) {
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupCopyright className="CopyrightC8bdeb4aEcd14098947f88ee3941b840" parentTag={buildClassName("CopyrightC8bdeb4aEcd14098947f88ee3941b840", parentTag)} {...props} />
  );
}

// id: "b8861936-4344-4b64-a871-b581e163098e"
// title: ""
// type: :text
// key: "href"
// parent_id: "50eb2226-ba56-46b8-8a9f-21c197a1d29c"
export const HrefB886193643444b64A871B581e163098e = "/join";

// id: "6441100d-caf1-4dd4-b052-d2ed9361f3ec"
// title: "Short Header"
// type: :html
// key: "short-header"
// parent_id: nil
export function ShortHeader6441100dCaf14dd4B052D2ed9361f3ec(props: any) {
  const Link = AppStore.presets["Link"];
  const PrimaryNavigation = AppStore.presets["PrimaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} ShortHeader6441100dCaf14dd4B052D2ed9361f3ec site-header`}>
      <div className="background-image" />
      <div className="header-top">
        {props["linked-logo"] || <Link className="LinkedLogo209fb66c4d474815Aa00C80823cc9cd3" parentTag={buildClassName("LinkedLogo209fb66c4d474815Aa00C80823cc9cd3", parentTag)} label={<DefaultLogoBfb6a91d3409483980e6C31b3a50e5be parentTag="Label6f5472eeA0b342caA6672b9b529ee4b3" alt="logo" />} {...props} />}
        {props["navigation"] || <PrimaryNavigation className="NavigationEa5e257bE2264f758a78Bfa72721bbb8" parentTag={buildClassName("NavigationEa5e257bE2264f758a78Bfa72721bbb8", parentTag)} navMenuSlug="members-primary-nav" {...props} />}
      </div>
    </div>
  );
}

// id: "132bc6a4-b2fc-4650-8404-ec358537ef99"
// title: ""
// type: :reference
// key: "about-susan-header"
// parent_id: "4c0dc444-4d5e-4051-83db-f6a0ad996433"
export function AboutSusanHeader132bc6a4B2fc46508404Ec358537ef99(props: any) {
  return (
    <MembersAreaHeaderOldFc7868f8Ac0749e6875a1e00c68345db parentTag="AboutSusanHeader132bc6a4B2fc46508404Ec358537ef99" {...props} />
  );
}

// id: "df9c88f5-b00a-4a26-84ff-5fc4ab19a81e"
// title: "Header Top"
// type: :reference
// key: "header-top"
// parent_id: "4c0dc444-4d5e-4051-83db-f6a0ad996433"
export function HeaderTopDf9c88f5B00a4a2684ff5fc4ab19a81e(props: any) {
  return (
    <DefaultHeaderTop071fdd249ede4246999bF08706f717ee parentTag="HeaderTopDf9c88f5B00a4a2684ff5fc4ab19a81e" {...props} />
  );
}

// id: "7837105a-2ae0-4a67-85ed-2ba73e199b55"
// title: ""
// type: :reference
// key: "header"
// parent_id: "a5dcb418-035e-4a5f-92c1-45632725e805"
export function Header7837105a2ae04a6785ed2ba73e199b55(props: any) {
  return (
    <SecondaryMarketingHeaderBc93fe8a5c6141d0A496541fd2d4f716 parentTag="Header7837105a2ae04a6785ed2ba73e199b55" title="Join Us" {...props} />
  );
}

// id: "f0dab9ba-6154-4cc8-8160-a6dd95c864af"
// title: ""
// type: :text
// key: "title"
// parent_id: "7837105a-2ae0-4a67-85ed-2ba73e199b55"
export const TitleF0dab9ba61544cc88160A6dd95c864af = "Join Us";

// id: "25cfe53c-2641-4c11-9992-57489acc0841"
// title: "Secondary Page"
// type: :html
// key: "secondary-page"
// parent_id: nil
export function SecondaryPage25cfe53c26414c11999257489acc0841(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} SecondaryPage25cfe53c26414c11999257489acc0841 gf-page-layout`}>
      {props["header"] || <SecondaryMarketingHeaderBc93fe8a5c6141d0A496541fd2d4f716 parentTag="Header2cd47e35942a43af9f2aC67c3487d390" title="Secondary Page" {...props} />}
      {props.children}
      {props["footer"] || <DefaultFooterCc240e6b6de845da9e98B6871451f0ae parentTag="Footer368691cd5ed147a18f6f7907b0f20f7d" {...props} />}
    </div>
  );
}

// id: "034726e6-fdf0-4907-9c6c-c6894005e717"
// title: ""
// type: :gf_preset
// key: "linked-logo"
// parent_id: "071fdd24-9ede-4246-999b-f08706f717ee"
export function LinkedLogo034726e6Fdf049079c6cC6894005e717(props: any) {
  const Link = AppStore.presets["Link"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Link className="LinkedLogo034726e6Fdf049079c6cC6894005e717" parentTag={buildClassName("LinkedLogo034726e6Fdf049079c6cC6894005e717", parentTag)} label={<DefaultLogoBfb6a91d3409483980e6C31b3a50e5be parentTag="Label2d74e863Fc984613Bd689342f946d6df" alt="logo" />} className="linked-logo" url="/" {...props} />
  );
}

// id: "decafed5-301e-4de4-abc7-8eabecea51eb"
// title: ""
// type: :reference
// key: "header"
// parent_id: "6d0e7dde-5b89-4012-b317-2d2b8e701f72"
export function HeaderDecafed5301e4de4Abc78eabecea51eb(props: any) {
  return (
    <MembersAreaHeaderOldFc7868f8Ac0749e6875a1e00c68345db parentTag="HeaderDecafed5301e4de4Abc78eabecea51eb" {...props} />
  );
}

// id: "8b8a56a6-c548-471b-8b74-befa350529b1"
// title: ""
// type: :gf_preset
// key: "navigation"
// parent_id: "071fdd24-9ede-4246-999b-f08706f717ee"
export function Navigation8b8a56a6C548471b8b74Befa350529b1(props: any) {
  const PrimaryNavigation = AppStore.presets["PrimaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PrimaryNavigation className="Navigation8b8a56a6C548471b8b74Befa350529b1" parentTag={buildClassName("Navigation8b8a56a6C548471b8b74Befa350529b1", parentTag)} className="navigation" navMenuSlug="marketing-primary-nav" {...props} />
  );
}

// id: "ae5256ce-3bca-468e-8b49-8825c4da4db7"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "b0a05cee-b2a9-4de1-b3dc-5dad4227bc1a"
export const PostSlugAe5256ce3bca468e8b498825c4da4db7 = "home-page-posts2";

// id: "3d7c1854-ada4-4edb-a74d-19ab3db9bc58"
// title: "Default Header Reference"
// type: :reference
// key: "default-header"
// parent_id: nil
export function DefaultHeader3d7c1854Ada44edbA74d19ab3db9bc58(props: any) {
  return (
    <SecondaryMarketingHeaderBc93fe8a5c6141d0A496541fd2d4f716 parentTag="DefaultHeader3d7c1854Ada44edbA74d19ab3db9bc58" navMenuSlug="marketing-primary-nav" title="Apply" {...props} />
  );
}

// id: "ea5e257b-e226-4f75-8a78-bfa72721bbb8"
// title: ""
// type: :gf_preset
// key: "navigation"
// parent_id: "6441100d-caf1-4dd4-b052-d2ed9361f3ec"
export function NavigationEa5e257bE2264f758a78Bfa72721bbb8(props: any) {
  const PrimaryNavigation = AppStore.presets["PrimaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PrimaryNavigation className="NavigationEa5e257bE2264f758a78Bfa72721bbb8" parentTag={buildClassName("NavigationEa5e257bE2264f758a78Bfa72721bbb8", parentTag)} navMenuSlug="members-primary-nav" {...props} />
  );
}

// id: "cbfc990f-def9-493b-8daf-245ebbcc726c"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "1b73e945-c298-48f9-9cf6-2e12cc0d8e61"
export function FooterCbfc990fDef9493b8daf245ebbcc726c(props: any) {
  return (
    <DefaultFooterCc240e6b6de845da9e98B6871451f0ae parentTag="FooterCbfc990fDef9493b8daf245ebbcc726c" {...props} />
  );
}

// id: "25b73777-30a0-4000-a66a-12e63adfcf91"
// title: ""
// type: :html
// key: "about-susan-main"
// parent_id: "4c0dc444-4d5e-4051-83db-f6a0ad996433"
export function AboutSusanMain25b7377730a04000A66a12e63adfcf91(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <main className={`${parentTag || ""} AboutSusanMain25b7377730a04000A66a12e63adfcf91`}>
      <div className="background-image">
      </div>
      <div className="text-block first">
        <div className="opacity">
        </div>
        <div className="text">
          <h2 className="heading">
            Welcome to the house of Breath.
          </h2>
          <p>
            Here we can slow down, exhale the old, and breathe in the new.
          </p>
          <p>
            Are you looking for deeper ways to connect with yourself?
          </p>
          <p>
            Do you feel desire to experience MORE?
          </p>
          <p>
            More...
          </p>
          <p>
            pleasure, security, magic, wholeness...
          </p>
          <p>
            MORE TURNED ON WITH YOUR LIFE.
          </p>
          <p>
            Answer the beckoning of the heart,
          </p>
          <p>
            I&#39;m here to support you on this journey.
          </p>
        </div>
      </div>
      <div className="page-row color-scheme-1">
        <div className="text-block centered-page-content">
          <div className="text">
            <p className="heading">
              Discover the magic you behold
            </p>
            <p>
              When we get overwhelmed by life and navigate difficult situations, we
              can forget our own magic. Sometimes we are shut down and disconnected
              from our body, our pleasure, our purpose.
            </p>
            <p>
              It&#39;s okay to ask for help, it&#39;s my honor to help remind you. Let&#39;s
              take time to build trust and learn about what you are missing.
            </p>
            <p>
              Sacred space gives us an opportunity to loosen up tension in the body.
              Clear out old chakra patterns. Remember what it feels like to be your
              magical integrated self.
            </p>
            <p>
              House of Breath is a Temple. Serene, sensual, playful.
            </p>
            <div className="button-container">
              <a href="/about/offerings" className="Button transition">
                Explore my Offerings
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="image-block">
      </div>
      <div className="page-row color-scheme-1">
        <div className="text-block centered-page-content testimonials">
          <div className="heading">
            Testimonials
          </div>
          <div className="testimonial">
            <div className="image-container">
              <img src="https://mp1md-pub.s3.amazonaws.com/orgs/tastesoftantra/images/Shout.jpg" alt="photo of CK" />
            </div>
            <div className="text-container">
              <p>
                I felt a warm, tight feeling in my throat as Susan was working on
                opening my throat chakra. I thought of people who I let take my
                voice away and my inner self said &quot;NO MORE, This is my voice, I will
                speak my truth&quot;
              </p>
              <p>
                — CK
              </p>
            </div>
            <div className="bottom" />
          </div>
          <div className="testimonial">
            <div className="image-container">
              <img src="https://mp1md-pub.s3.amazonaws.com/orgs/tastesoftantra/images/Relaxation.jpeg" alt="photo of BB" />
            </div>
            <div className="text-container">
              <p>
                She has a loving intuition that meets you where you are. She helps
                you relax into healing yourself while allowing the possibilities of
                what your life can be to blossom.
              </p>
              <p>
                — BB
              </p>
            </div>
            <div className="bottom" />
          </div>
          <div className="testimonial">
            <div className="image-container">
              <img src="https://mp1md-pub.s3.amazonaws.com/orgs/tastesoftantra/images/Touch.jpg" alt="photo of CK" />
            </div>
            <div className="text-container">
              <p>
                Through her touch, Susan makes a visceral connection that reaches my
                core, sending reverberations throughout my body.
              </p>
              <p>
                — R
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="contact-small">
      </div>
      <div className="contact-container">
        <div className="contact-form block color-scheme-2">
          <div className="heading">
            Reach out for a free consultation!
          </div>
          <p>
            When you feel called to any of my services, it begins with a discovery
            call with SuSun. This is to make sure Tastes of Tantra is a good fit for
            yourself and your relationships!
          </p>
          <div className="button-container">
            <a href="/members/messages/x1RwUD7TogtZzODN" className="Button color2 transition">
              Message SuSun
            </a>
          </div>
        </div>
        <div className="image">
        </div>
      </div>
    </main>
  );
}

// id: "a5b7767e-5332-4761-a72b-f702790995bd"
// title: ""
// type: :text
// key: "title"
// parent_id: "38066c6b-797e-4645-ad4e-a20a2bcf5fdf"
export const TitleA5b7767e53324761A72bF702790995bd = "Leveling";

// id: "1f170a5f-e41e-4904-9f8e-7f32d9e84316"
// title: ""
// type: :text
// key: "title"
// parent_id: "3d7c1854-ada4-4edb-a74d-19ab3db9bc58"
export const Title1f170a5fE41e49049f8e7f32d9e84316 = "Apply";

// id: "50420bb8-a52d-4997-9384-c722f8ba4d5f"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "8b8a56a6-c548-471b-8b74-befa350529b1"
export const NavMenuSlug50420bb8A52d49979384C722f8ba4d5f = "marketing-primary-nav";

const Components = {
  Header93b281a35e974923B078F60713f25c42,
  MarketingCardsAb8b87ee08634edeA41f73026a5f273b,
  Footer6e8678b9E81142c297a3C4a2a3912e64,
  Alt49ef487a3e0d457bA941D252242bb5ff,
  Href198a2f3cD02e4bd4983140c700168128,
  ResourcesPage835a7006Fedf4a3c96f60c8578d33dd5,
  HeroB2c60fb59ea6432aB2b3B8dde85a6ce2,
  NavMenuSlug4bb8d6bd65614d598bc51adb8c1d543d,
  AboutSusanHeaderCe33b72d9e0b4d1d80910c100757ba19,
  Title07bd4b2eB5974cddB1b1Be38650566ce,
  MemberPagesOld9d3344159a764415A2d583babbf3fcca,
  TitleA1b9cc03A6254837A608F781e5e93b13,
  Header38066c6b797e4645Ad4eA20a2bcf5fdf,
  SecondaryNav3ad71a9bFbc34044Be197d7c5c7146be,
  Header49186fffC4a34c9a994f47b0f66e8727,
  Label6f5472eeA0b342caA6672b9b529ee4b3,
  DefaultHeaderTop071fdd249ede4246999bF08706f717ee,
  HomePage1b73e945C29848f99cf62e12cc0d8e61,
  Button50eb2226Ba5646b88a9f21c197a1d29c,
  BackgroundImage0a104597B8e14cb8B4d3Cc93d270aa23,
  Footer0c388b3408c74ec2Bca87004c328c44a,
  TitleF5e2297533ed4a498d833a39d85d79ae,
  MarketingBody5563864f8a25444cA7e7E7adc834add8,
  AboutLevelingPage8b19b3d6071d4d4bA2e3Cd7e0536b5b3,
  Label8b5d91db05f74be38a097267d0c97010,
  Footer368691cd5ed147a18f6f7907b0f20f7d,
  GroupflowAd71e0687e01415e9b42D99dce697150,
  ClassA13755591a104f17Adf04da4586b3089,
  Title72f7eb280d92491898fb5e7478a8e8d0,
  SignupPagesA69374e40dfa4a189b5e1d326a09e345,
  DefaultLogoBfb6a91d3409483980e6C31b3a50e5be,
  HeaderTopC6947626F9dd4d28Be999e54e100096b,
  HeaderA53e13e4Ec8247b08f5aEbe49c1db91d,
  Header2cd47e35942a43af9f2aC67c3487d390,
  Label2d74e863Fc984613Bd689342f946d6df,
  PublicEventsPageFd53b17298d24c969dc3C331f3015048,
  Footer3d48beec3b63488a8fedD838fd483470,
  Header7357f4e916604887A00340db9e403349,
  Links6881901dDbdb4b8182528bca75e98a1a,
  NavMenuSlugF0794eabE04c4c879e26002c8073476c,
  NavigationF1b701ff476c4a52A80aA032a4773463,
  SecondaryMarketingHero927c6e9418c645b5945180d1edd3a1d7,
  MembersAreaDefault7d66cde58534459c965b5b9012c035f1,
  Title3cb639f8A6ff473d95969a7363f3837f,
  PostSlug0414380b3543409cA1f3Bb21fe2bd0c4,
  Footer4eaee5ba33904cf29eec930622dc8549,
  Class210e2856794540469fd37019daf8760c,
  AboutSusan4c0dc4444d5e405183dbF6a0ad996433,
  DefaultFooterCc240e6b6de845da9e98B6871451f0ae,
  Footer6f24f00bA0d44b61A3492965ba422092,
  Title7624d10f144d4649A9797bad253f0ff1,
  Header5a2a8fc48cce46afA5cb357490033e22,
  PostSlugF884d2f6831b405e856bE704f0c802c3,
  MessagePages6d0e7dde5b894012B3172d2b8e701f72,
  HomeHeaderEabc1b81A9494986Bcf674098e4558e8,
  Body838b17a79be9466bB7d2Eec8def13281,
  MarketingCardsB0a05ceeB2a94de1B3dc5dad4227bc1a,
  Class139ba2da7a5d4843B61dE0832b539c85,
  TitleB01b3de5D10e468cA91dF9118cf6fe1a,
  AdminPages761775b054d641bf93044773a20b6bb7,
  MembersAreaHeaderOldFc7868f8Ac0749e6875a1e00c68345db,
  WelcomeBackE62b5ab39e1c4d0e8bf02580314720e7,
  Hero2e8b1e2cC0fc4e65800489adb5a6cd26,
  TitleE559f2a3Ba584d74A2fe8eb9bd33f100,
  LabelEf105dc486c34b9893455d3c283c80d7,
  HomePageHero2820f6c33d674753986a3bd1298c4f6f,
  LogoFf35e4d41148430c9b2b63af39c68626,
  Footer90d64ebdA5944c6cAc0cBcc26931f6a6,
  FooterE6cdd07cF45b4584A515F5485035124c,
  ContentSlug9bfc3b145c184fb5Afda3697bf19839e,
  NavMenuSlug62816ae60e8c41258ae0Eca21db15e2b,
  AboutOfferings18dceb9fFf944f4dAd5934c42f458a84,
  NavMenuSlugDa77ccf9Bcbc48a08965C30469d0686d,
  HeaderTop89b61f840574467e82cfE490d817f3aa,
  BodyA33e76b14e9d46858c77654c7f89f115,
  Url7b1f7451055c4956Acbb0eae3f6252d1,
  NavMenuSlug60453c6f3b454871Ab715fd83801da31,
  SecondaryMarketingHeaderBc93fe8a5c6141d0A496541fd2d4f716,
  Header2490b2f512ae4c4a945cDfcc1dbec9b9,
  LinkedLogo209fb66c4d474815Aa00C80823cc9cd3,
  Header99929f2dE69b4a6fA1f5457714623d02,
  NavMenuSlug4dc2e39e09cd405f9fb79dde2e60997b,
  NavMenuSlug991c50e5238e402eB047Ff09994e3430,
  JoinUsPageA5dcb418035e4a5f92c145632725e805,
  QuoteF3d75a66112c4b188f736251164b57a7,
  HeaderTop642b355a8a5d4eaf9abe83986baf06ed,
  Title4e6b9cdf9a6144abA59fE5702ac3780e,
  Class7c5f898cF7ca4a85A6ebD851af3134df,
  AboutUsPage74e798882a33405d9c7a52636e1e4e48,
  BackgroundImageD31d5c927418447eA694940eff4a32be,
  Footer514efbf0A4054446B960889811f45913,
  ButtonClass21e3de76Db394b66A8e562c9d85219c4,
  PostSlug5c08bd7889e04d77B658Acb183fbd995,
  PageQuote4735746fAd7a48b483beDb41374fbe66,
  ImageUrl9ab527dbEac14b75A702167f96379082,
  Header0657433f839d47d5925c8ffd02f66d07,
  CopyrightC8bdeb4aEcd14098947f88ee3941b840,
  HrefB886193643444b64A871B581e163098e,
  ShortHeader6441100dCaf14dd4B052D2ed9361f3ec,
  AboutSusanHeader132bc6a4B2fc46508404Ec358537ef99,
  HeaderTopDf9c88f5B00a4a2684ff5fc4ab19a81e,
  Header7837105a2ae04a6785ed2ba73e199b55,
  TitleF0dab9ba61544cc88160A6dd95c864af,
  SecondaryPage25cfe53c26414c11999257489acc0841,
  LinkedLogo034726e6Fdf049079c6cC6894005e717,
  HeaderDecafed5301e4de4Abc78eabecea51eb,
  Navigation8b8a56a6C548471b8b74Befa350529b1,
  PostSlugAe5256ce3bca468e8b498825c4da4db7,
  DefaultHeader3d7c1854Ada44edbA74d19ab3db9bc58,
  NavigationEa5e257bE2264f758a78Bfa72721bbb8,
  FooterCbfc990fDef9493b8daf245ebbcc726c,
  AboutSusanMain25b7377730a04000A66a12e63adfcf91,
  TitleA5b7767e53324761A72bF702790995bd,
  Title1f170a5fE41e49049f8e7f32d9e84316,
  NavMenuSlug50420bb8A52d49979384C722f8ba4d5f
}

export default Components;